import axios, { getData } from "lib/axios"

export const nexPlayVideo = async () => {
  return axios.get(`nex_plays`).then(getData)
}
